import React from 'react';
import './abstract.css';

const AbstractSubmissionGuideline = () => {
  return (
    <div className="abstract-guidelines">
      <h2>Abstract Submission Guideline</h2>

      <h3>General Guidelines</h3>
      <ul>
        <li>
          Abstracts can only be submitted online on our website{' '}
          <a href="https://conference.smdc.edu.pk" target="_blank" rel="noopener noreferrer">
            https://conference.smdc.edu.pk
          </a>
        </li>
        <li>All abstracts must be written in English; recommended Font Size: 12 [Calibri]</li>
        <li>
          The abstract should be structured under the following headings: Background, Objectives,
          Materials - Methods, Results and Conclusions.
        </li>
        <li>The abstract should not exceed 250 words.</li>
        <li>
          It is the author’s responsibility to submit a correct abstract. Any errors in spelling,
          grammar or scientific fact in the abstract text will be reproduced as typed by the author.
        </li>
        <li>
          All abstracts should be prepared according to the guidelines provided by the{' '}
          <a href="http://www.icjme.org" target="_blank" rel="noopener noreferrer">
            International Committee of Medical Journals
          </a>{' '}
          (<a href="http://www.icjme.org" target="_blank" rel="noopener noreferrer">www.icjme.org</a>); further details can be found on{' '}
          <a href="http://www.pubmed.com" target="_blank" rel="noopener noreferrer">
            www.pubmed.com
          </a>
        </li>
      </ul>

      <h3>Guidelines for Poster Presentation</h3>
      <ul>
        <li>Size of Poster: 36” x 48”</li>
        <li>Layout: Portrait</li>
        <li>Graphs: Maximum (03) three in number</li>
        <li>Pictures: Maximum (04) four in number</li>
      </ul>

      <h3>Copyright Policy</h3>
      <p>
        Abstracts should not include libelous or defamatory content. Material presented in abstracts should not violate any copyright laws. If figures/graphics/images have been taken from sources not copyrighted by the author, it is the author’s sole responsibility to secure the rights from the copyright holder in writing to reproduce those figures/graphics/images for both worldwide print and web publication. All reproduction costs charged by the copyright holder must be borne by the author.
      </p>

      <h3>Plagiarism</h3>
      <p>
        The conference organizers consider plagiarism as serious professional misconduct. All abstracts may be screened for plagiarism and, if identified, the abstract and any other abstracts submitted by the same author will be rejected. However, if identified after publication/presentation, the author will bear the whole responsibility.
      </p>
      <p>
        An abstract which has been previously published or presented at a national, regional or international meeting can only be submitted provided that there are new methods, findings, updated information or other valid reasons for submitting.
      </p>

      <h3>Ethical Research Declaration</h3>
      <p>
        The conference supports only research that has been conducted according to the protocol approved by the institutional or local committee on ethics in human investigation. Where no such committee exists, the research should have been conducted in accordance with the principles of the Declaration of Helsinki of the World Medical Association.
      </p>

      <h3>Submission Confirmation</h3>
      <p>
        After submission of the abstract, a confirmation email will be sent to the Author.
      </p>

      <h3>Abstract Review</h3>
      <p>
        All submitted abstracts will go through a blind peer-review process carried out by an international reviewing committee. Each abstract will be reviewed by at least three reviewers.
      </p>

      <h3>Abstract Selection</h3>
      <p>
        The Scientific Program Committee makes the final selection of abstracts to be included in the conference program. Abstracts can be selected for oral presentation in oral abstract sessions or to be presented as a poster. A small number of highest-scoring posters are selected for presentation in oral poster discussion sessions; the majority of the posters will be displayed in the Poster Exhibition.
      </p>

      <h3>Notification of Acceptance or Rejection</h3>
      <p>
        Notification of acceptance or rejection will be sent to the submitting (corresponding) author through email. Please note that only the corresponding author will receive an email concerning the abstract and is responsible for informing all co-authors of the status of the abstract.
      </p>

      <h3>Publication of Accepted Abstracts</h3>
      <p>
        The submission of the abstracts constitutes the authors’ consent to publication. If the abstract is accepted, the authors agree that their abstracts can be published in the conference booklet. Authors retain the copyright of their abstracts. Accepted abstracts may, therefore, be published on our websites and in related publications.
      </p>

      <h3>Specific Guidelines for Abstract Submission</h3>
      <p>
        Abstracts should be in line with the theme of the conference which is “Bridging Theory and Practice”.
      </p>

      <h3>Disciplines</h3>
      <p>Abstracts can be sent in the following Disciplines:</p>
      <ul>
        <li>Basic Sciences</li>
        <li>Clinical Sciences</li>
        <li>Medicine and Allied</li>
        <li>Surgery and Allied</li>
        <li>Diagnostics</li>
        <li>Radiology</li>
        <li>Pathology</li>
        <li>Medical Education</li>
        <li>Bioethics</li>
        <li>Technologies in Healthcare</li>
        <li>Nursing and Allied Health Sciences</li>
      </ul>
    </div>
  );
};

export default AbstractSubmissionGuideline;
